import { render, staticRenderFns } from "./text-box-button-combo.vue?vue&type=template&id=fb6a8d50&"
import script from "./text-box-button-combo.vue?vue&type=script&lang=js&"
export * from "./text-box-button-combo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports